import {defineComponent, render, h} from 'vue';
import t from "@zh-or/lib/index";
import confirm from '../components/confirm.vue';

function createComponent(view, props, child/*child | slots*/) {
    /*
    * 创建后需要调用 mount 挂载
    * 使用完毕需要调用 destory 销毁
    * */

    return {
        com: h(view, props, child),
        vm: null,
        wrap: null,
        root: null,
        mount(root, isChild = true) {
            this.root = root || document.createElement('div');
            if(isChild) {
                /*包一层div*/
                this.wrap = document.createElement('div');
                this.root.appendChild(this.wrap);
            } else {
                this.wrap = this.root;
            }

            render(this.com, this.wrap);
            this.vm = this.com.component;

        },
        unmount() {
            render(null, this.wrap);
            if(this.root != this.wrap) {
                this.root.removeChild(this.wrap);
            }
        },
    }
}

export default function show(title, msg, okStr, cancelStr, tpl) {
    return new Promise((resolve, reject) => {
        let obj = createComponent(confirm, {
            title,
            msg,
            okStr: okStr,
            cancelStr: cancelStr,
            tpl: tpl,
            ok: () => {
                console.log('ok')
                obj.vm.exposed.hide();
                resolve();
                setTimeout(() => obj.unmount(), 200);
            },
            cancel: () => {
                obj.vm.exposed.hide();
                reject();
                setTimeout(() => obj.unmount(), 200);
            }
        });
        obj.mount(document.body);
    });
}
